<template>
    <div class="jumbotron text-white" style="background-color: #002554;">
        <h1>Email Signature Generator</h1>
        <p>Enter your details in the form below to create your email signature.  Once everything looks correct in the preview, click 'Copy Signature' to copy to the clipboard.</p>
    </div>
</template>

<script>
export default {
  name: "Intro",
  props: { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#intro{
  margin: 3rem 0;
} 

</style>


// WEBPACK FOOTER //
// src/components/Intro.vue